/* ==========================================================================
   Layout readout — inert unless the URL carries ?debug=layout

   Exists because a phone can render a layout the desktop emulator will not
   reproduce: pinch zoom, a visual viewport narrower than the layout viewport,
   a browser UI inset, or an element overhanging an edge. Guessing at that from
   a screenshot burns rounds. This prints the numbers that separate those
   causes so one screenshot settles it.
   ========================================================================== */

(function () {
  'use strict';

  if (window.location.search.indexOf('debug=layout') === -1) return;

  function gaps(sel) {
    var el = document.querySelector(sel);
    if (!el) return 'absent';
    var r = el.getBoundingClientRect();
    if (!r.width) return 'not rendered';
    var L = Math.round(r.left);
    var R = Math.round(window.innerWidth - r.right);
    return 'L' + L + ' R' + R + ' W' + Math.round(r.width) + (Math.abs(L - R) <= 3 ? '  OK' : '  OFF by ' + Math.abs(L - R));
  }

  // The variant fieldset is full width, so measuring IT always reads centred
  // even when the pills inside are not. What matters is the first and last
  // pill against the fieldset's own edges.
  function pillGaps() {
    var fs = document.querySelector('.product-form__input--pill, .product-form__input--swatch');
    if (!fs) return 'absent';
    var labels = fs.querySelectorAll('label');
    if (!labels.length) return 'no pills';
    var fr = fs.getBoundingClientRect();
    var lefts = [];
    var rights = [];
    [].forEach.call(labels, function (l) {
      var r = l.getBoundingClientRect();
      lefts.push(r.left);
      rights.push(r.right);
    });
    var L = Math.round(Math.min.apply(null, lefts) - fr.left);
    var R = Math.round(fr.right - Math.max.apply(null, rights));
    var rows = {};
    [].forEach.call(labels, function (l) {
      rows[Math.round(l.getBoundingClientRect().top)] = 1;
    });
    return 'L' + L + ' R' + R + '  ' + Object.keys(rows).length + ' row(s)' +
      (Math.abs(L - R) <= 2 ? '  OK' : '  OFF by ' + Math.abs(L - R));
  }

  // A centred flex line shifts left when something invisible sits at its end.
  // The prime suspect is Dawn's hidden radio inputs: they carry a right margin
  // and are only harmless while they are out of flow. If a browser leaves them
  // in flow they add width to the line, and the visible pills slide left by
  // half of it. This reports whether that is happening on THIS device.
  function hiddenInputs() {
    var fs = document.querySelector('.product-form__input--pill, .product-form__input--swatch');
    if (!fs) return 'absent';
    var inputs = fs.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return 'none';
    var cs = getComputedStyle(inputs[0]);
    var inFlow = cs.position !== 'absolute' && cs.position !== 'fixed';
    var each = Math.round(
      (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0) + inputs[0].getBoundingClientRect().width
    );
    return inputs.length + '× pos:' + cs.position + ' m:' + cs.marginLeft + '/' + cs.marginRight +
      (inFlow ? '  IN FLOW, steals ' + each * inputs.length + 'px -> shifts pills ' + Math.round(each * inputs.length / 2) + 'px left' : '  out of flow OK');
  }

  function render() {
    var vv = window.visualViewport;
    var rows = [
      ['window.innerWidth', window.innerWidth],
      ['documentElement.clientWidth', document.documentElement.clientWidth],
      ['visualViewport.width', vv ? Math.round(vv.width) : 'n/a'],
      ['visualViewport.scale', vv ? vv.scale.toFixed(3) : 'n/a'],
      ['visualViewport.offsetLeft', vv ? Math.round(vv.offsetLeft) : 'n/a'],
      ['devicePixelRatio', window.devicePixelRatio],
      ['scrollWidth', document.documentElement.scrollWidth],
      ['scrollX', Math.round(window.scrollX || window.pageXOffset)],
      ['— element gaps —', ''],
      ['info container', gaps('.product__info-container')],
      ['buy buttons', gaps('.product-form__buttons')],
      ['variant fieldset', gaps('.product-form__input--pill')],
      ['size pills', pillGaps()],
      ['hidden radios', hiddenInputs()],
      ['trust card', gaps('.pdp-trust-card')],
      ['pair card', gaps('.biw-card')],
      ['review card', gaps('.pdp-review-card')],
      ['utmarkt card', gaps('.review-summary-card')],
      ['header', gaps('.header')],
    ];

    var box = document.getElementById('voffen-debug') || document.createElement('div');
    box.id = 'voffen-debug';
    box.style.cssText =
      'position:fixed;left:0;right:0;bottom:0;z-index:2147483647;background:#111;color:#0f0;' +
      'font:11px/1.45 ui-monospace,Menlo,Consolas,monospace;padding:10px 12px;max-height:60vh;overflow:auto;';
    box.innerHTML =
      '<b style="color:#fff">LAYOUT READOUT</b> (remove ?debug=layout to hide)<br>' +
      rows
        .map(function (r) {
          return '<span style="color:#888">' + r[0] + '</span> ' + r[1];
        })
        .join('<br>');
    if (!box.parentNode) document.body.appendChild(box);
  }

  function boot() {
    render();
    // Re-render on anything that changes the geometry, so the numbers on
    // screen always match what is actually being looked at.
    window.addEventListener('resize', render);
    window.addEventListener('scroll', render, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', render);
      window.visualViewport.addEventListener('scroll', render);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
